import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import CompanyViewCardSummary from 'components/company-view/company-view-card/summary/summary';
import CompanyViewCardSummaryBlank from 'components/company-view/company-view-card/summary/summary-blank';
import CompanyViewCardRating from 'components/company-view/company-view-card/rating/rating';
import CompanyViewCardRatingBlank from 'components/company-view/company-view-card/rating/rating-blank';
import type { CompanyInterface } from 'interfaces/company.interface';
import './company-view-card.desktop.scss';

const CompanyViewCardDesktop: React.FC = (): ReactElement => {
    const company = useSelector(
        (state: { company: CompanyInterface; }) => state.company
    );

    return (
        <div className="container">
            <div className="company-view-card">
                {company.isCustomer ? <CompanyViewCardSummary /> : <CompanyViewCardSummaryBlank />}
                {
                    company.isCustomer
                        ? <CompanyViewCardRating description={company.opineoDescription} company={company} />
                        : <CompanyViewCardRatingBlank description={company.opineoDescription} company={company} />
                }
            </div>
        </div>
    );
};

export default CompanyViewCardDesktop;
